<template>
  <VanPopup
    :show="show"
    @update:show="emit('update:show', $event)"
    class="p-10"
    position="center"
    round
    teleport="body"
  >
    <div class="flex flex-col items-center justify-center w-full h-full gap-5">
      <div class="flex flex-col items-center justify-center gap-2">
        <i :class="['iconfont  text-[40px] ', momentInfo?.icon]"></i>
      </div>
      <div class="flex flex-col gap-2 w-full">
        <div class="flex flex-col gap-2">
          <span class="font-bold">{{ momentInfo?.name }}</span>
          <textarea
            v-model="publishMomentText"
            :placeholder="$t('Texts.sharePlaceholder')"
            class="textarea textarea-bordered min-h-32"
          />
        </div>
      </div>
      <div class="flex gap-2 justify-between items-center">
        <button
          class="btn rounded btn-primary btn-sm flex-1"
          @click="clickShareMoment"
        >
          {{ $t("share.name") }}
        </button>
        <button
          class="btn rounded btn-sm flex-1"
          @click="emit('update:show', false)"
        >
          {{ $t("Buttons.cancel") }}
        </button>
      </div>
    </div>
  </VanPopup>
</template>

<script lang="ts" setup>
import api, { PostMomentParams } from "@/modules/api";
import { useMate } from "@/stores/mate";
import { useMoment } from "@/stores/moment";
import { showLoadingToast, showSuccessToast } from "vant";
import { computed } from "vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
  shareType: {
    type: String,
    required: true,
  }, // collection, game, story, user, roleplayAnswer
  shareId: {
    type: Number,
    required: true,
  },
  mateUuid: {
    type: String,
  },
  storyGameId: {
    type: Number,
  },
});

const emit = defineEmits<{
  (e: "update:show", show: boolean): void;
}>();

const momentInfo = computed(() => {
  if (props.shareType === "collection") {
    return {
      name: t(`Texts.introCollection`),
      icon: "icon-collection",
    };
  } else if (props.shareType === "game") {
    return {
      name: t(`Texts.introGame`),
      icon: "icon-script-game",
    };
  } else if (props.shareType === "story") {
    return {
      name: t(`Texts.contentChapter`),
      icon: "icon-story1",
    };
  } else if (props.shareType === "roleplayAnswer") {
    return {
      name: t(`Texts.introRoleplayAnswer`),
      icon: "icon-roleplay",
    };
  } else {
    return {
      name: t(`Texts.introUser`),
      icon: "icon-user",
    };
  }
});

// moment
const publishMomentText = ref("");
const clickShareMoment = async () => {
  const loadingToast = showLoadingToast({
    message: t("Message.publishingShare"),
  });
  const params: PostMomentParams = {
    mateId: props.mateUuid || useMate().currentMate!.uuid,
    text: publishMomentText.value,
    visibility: 1,
    status: 1,
  };
  const { shareId, shareType, storyGameId } = props;
  if (shareType === "collection") {
    params.collectionId = shareId;
  } else if (shareType === "game") {
    params.galGameId = shareId;
  } else if (shareType === "story") {
    params.storyGameId = storyGameId;
    params.storyId = shareId;
  } else if (shareType === "roleplayAnswer") {
    params.roleplayAnswerId = shareId;
  }

  await api.createMoment(params);
  const moment = useMoment();
  emit("update:show", false);
  await moment.fetchMomentList(false, 0);
  loadingToast.close();
  showSuccessToast(t("Message.publishSuccess"));
};
</script>
